import { render, staticRenderFns } from "./DriverDistanceForm.vue?vue&type=template&id=53b01b96&"
import script from "./DriverDistanceForm.vue?vue&type=script&lang=js&"
export * from "./DriverDistanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports